import { css, keyframes } from '@emotion/react';
export var getPulseStyles = function getPulseStyles() {
  var color = "var(--ds-border-discovery, #8270DB)";
  var pulseKeyframes = keyframes({
    to: {
      boxShadow: '0 0 0 7px rgba(0, 0, 0, 0)'
    }
  });
  return css({
    display: 'inline-flex',
    borderRadius: '3px',
    boxShadow: "0 0 0 0 ".concat(color),
    animation: "".concat(pulseKeyframes, " 2s cubic-bezier(0.5, 0, 0, 1) 0.25s both 2")
  });
};